


















import { Component, Prop } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';
import Avatar from '@/components/common/Avatar.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { CheckIcon } from 'vue-feather-icons';
import { IProduct } from 'admiral-core';

@Component({
  components: { Multiselect, Avatar, CheckIcon },
})
export default class ProductSelect extends mixins(BaseMixin) {
  @Prop({ type: Boolean, default: () => false })
  multiple!: boolean;

  @Prop({ required: false, type: [Object, Array] })
  product!: IProduct | IProduct[];

  @Prop({ required: false, type: Array })
  errors!: string[];

  @Prop({ required: false, type: String, default: () => 'Produkt wählen' })
  placeholder!: string;

  updateProduct(product: IProduct | IProduct[]) {
    this.$emit('update-product', product);
    this.$emit('blur');
  }

  isSelected(id: string) {
    if (Array.isArray(this.product)) {
      return this.product.find((product: IProduct) => product.id === id);
    } else {
      return this.product.id === id;
    }
  }
}
